import {Pipe, PipeTransform} from '@angular/core';
import * as moment from 'moment';


@Pipe({
    name: 'durationFormatter'
})
export class DurationFormatterPipe implements PipeTransform {

    transform(duration: moment.Duration, format?: string): string {
        if ('hours' === format) {
            let minutes = Math.round(Number(duration) / 60000);
            let remMinutes = Math.round(minutes % 60);
            let fullHours = Math.round(minutes / 60);
            if (remMinutes > 5 && fullHours > 0) {
                return (fullHours -1)+ ':' + remMinutes;
            }
            return fullHours + ':' + remMinutes;
        } else if ('days' === format) {
            let hours = Math.round(Number(duration) / 3600000);
            //let remHours = Math.round(hours % 24);
            let fullDayss = Math.round(hours / 24);

            if ( fullDayss < 1) {
                return '< day';
            }
            return fullDayss + ' days' ;
        }
        return duration.humanize();
    }

}
